import gettext from './lang/gettext';

export const DIRTY_STATUS = 'dirty';
export const NOT_DIRTY_STATUS = 'not dirty';
export const UNPAID_BREAKS = 1;
export const PAID_BREAKS = 2;
export const FILTER_SUITES = {
  myschedule: 'myschedule',
  fullschedule: 'fullschedule',
  availableshifts: 'availableshifts',
  availability: 'availability',
  alllocactions: 'alllocactions',
  mylocations: 'mylocations',
  pendingapproval: 'pendingapproval',
};
export const CALENDAR_HOURS = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
];
export const CALENDAR_HOURS_US = [
  '12AM',
  '1AM',
  '2AM',
  '3AM',
  '4AM',
  '5AM',
  '6AM',
  '7AM',
  '8AM',
  '9AM',
  '10AM',
  '11AM',
  '12PM',
  '1PM',
  '2PM',
  '3PM',
  '4PM',
  '5PM',
  '6PM',
  '7PM',
  '8PM',
  '9PM',
  '10PM',
  '11PM',
];
export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];
export const PROJECTED_SALE_TYPES = {
  default: 'projectedDay',
  override: 'projectedDate',
};
export const ALL_DAY = gettext('All day');
export const DISPLAY_MODES = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  CUSTOM: 'custom',
  PAYROLL: 'payroll',
};
export const PROCESSING_MODES = {
  USER_SEPARATED: 'user-separated',
  USER_AGGREGATED: 'user-aggregated',
};
export const SHIFT_BLOCK_SOURCES = {
  TIME: 'TIME',
  DURATION: 'DURATION',
  ASSIGNEE: 'ASSIGNEE',
  POSITION: 'POSITION',
  LOCATION: 'LOCATION',
  TAG: 'TAG',
};
export const EVENT_STATUS = {
  PLANNING: 'planning',
  PUBLISHED: 'published',
  CANCELLED: 'cancelled',
  PENDING_ADMIN: 'pending_admin',
};

export const LEAVE_CAP_UNITS = [
  { value: 'DAYS', label: 'Days' },
  { value: 'HOURS', label: 'Hours' },
];

export const LEAVE_CAP_TYPES = [
  { value: true, label: 'In aggregate' },
  { value: false, label: 'By leave type' },
];

export const LEAVE_TYPE = 'leave';
export const LEAVE_SICK_TYPE = 'sick';
export const LEAVE_VACATION_TYPE = 'vacation';
export const LEAVE_UNPAID_VACATION_TYPE = 'unpaid_vacation';
export const LEAVE_SICK_NAME = 'Sick';
export const SHIFT_TYPE = 'shift';
export const NO_SHOW_TYPE = 'no_show';
export const SICK_CALLOUT_TYPE = 'sick_callout';
export const SUPPRESSION_TYPE = 'suppression';
export const BUSINESS_CLOSED_TYPE = 'business_closed';
export const HOLIDAY_RATE_TYPE = 'holiday_rate';
export const UNAVAILABILITY_TYPE = 'availability';
export const SHIFT_TYPES = [SHIFT_TYPE, NO_SHOW_TYPE, SICK_CALLOUT_TYPE];
export const ABSENCE_TYPES = [NO_SHOW_TYPE, SICK_CALLOUT_TYPE];
export const DAY_MARK_TYPES = [SUPPRESSION_TYPE, BUSINESS_CLOSED_TYPE, HOLIDAY_RATE_TYPE];

export const NO_SHOWS_DICT = {
  [NO_SHOW_TYPE]: 'no show',
  [SICK_CALLOUT_TYPE]: 'sick callout',
};

export const NO_SHOW_ASSIGN = 'assign';
export const NO_SHOW_OFFER = 'offer';
export const NO_SHOW_MAKE_AVAILABLE = 'available';
export const SHIFT_DELETE = 'delete';
export const SHIFT_ASSIGN = 'assign';
export const SHIFT_UASSIGN = 'uassign';
export const SHIFT_MAKE_AVAILABLE = 'available';
export const TASK_DELETE = 'delete';
export const TASK_ASSIGN = 'assign';
export const USER_UNINVITED = 'uninvited';
export const USER_INVITED = 'invited';
export const USER_UNVERIFIED = 'unverified';
export const USER_VERIFIED = 'verified';

// leaving for backward compatibility
export const NO_SHOW_ACTIONS = [
  {
    value: NO_SHOW_ASSIGN,
    label: 'Assign to an employee',
  },
  {
    value: 'unassign',
    label: 'Make unassigned',
  },
  {
    value: NO_SHOW_MAKE_AVAILABLE,
    label: 'Make available',
  },
  {
    value: NO_SHOW_OFFER,
    label: 'Offer shift',
  },
];

export const SHIFT_COVER_ACTIONS = [
  {
    value: SHIFT_DELETE,
    label: 'Leave uncovered',
  },
  {
    value: NO_SHOW_ASSIGN,
    label: 'Assign to an employee',
  },
  {
    value: 'unassign',
    label: 'Make unassigned',
  },
  {
    value: NO_SHOW_MAKE_AVAILABLE,
    label: 'Make available',
  },
  {
    value: NO_SHOW_OFFER,
    label: 'Offer shift',
  },
];

export const SHIFT_ACTIONS = [
  {
    value: SHIFT_DELETE,
    label: 'Delete the shifts',
  },
  {
    value: SHIFT_UASSIGN,
    label: 'Make unassigned',
  },
  {
    value: SHIFT_MAKE_AVAILABLE,
    label: 'Make available',
  },
  {
    value: SHIFT_ASSIGN,
    label: 'Assign to an employee',
  },
];

export const TASK_ACTIONS = [
  {
    value: TASK_DELETE,
    label: 'Delete the tasks',
  },
  {
    value: TASK_ASSIGN,
    label: 'Assign to an employee',
  },
];

export const RRULE_INTERVAL_THIS_WEEK = 100;

export const TIMESHEET_ENTRY_TYPES = {
  CLOCK_IN: 'clock_in',
  CLOCK_OUT: 'clock_out',
  BREAK_START: 'break_start',
  BREAK_END: 'break_end',
  AUTO_CLOCK_OUT: 'auto_clock_out',
  MARK_APPROVED: 'mark_approved',
  MARK_PENDING: 'mark_pending',
};

export const ICELANDIC_LCA = {
  DEFAULT_DAY_WORK_HOURS: 8,
  MONTH_OVERTIME_HOURS_MULTIPLIER: 1.8,
  EVENING_MULTIPLIER: 1.33,
  MORNING_AND_WEEKEND_MULTIPLIER: 1.45,
  HOLIDAY_MULTIPLIER: 1.9,

  MONTH_OVERTIME_HOURS_THRESHOLD: 172, // Any worked time that exceeds this threshold in a month is paid
  EVENING_THRESHOLD: 17, // Work after 17 on weekdays falls into this category
  MORNING_AND_WEEKEND_THRESHOLD: 7, // Work before 7 or on weekends fall into this category
};

export const SWAP_PENDING_STATUS = 'pending';
export const SWAP_ACCEPTED_STATUS = 'accepted';

export const ANALYTICS_EVENTS = {
  userOpened: 'user_opened',
  appShared: 'app_shared',
  orgSetupAddedPositions: 'org_setup_added_positions',
  orgSetupAddedUsers: 'org_setup_added_users',
  trialActivationModalShown: 'trial_activation_modal_shown',
  trialActivationModalStartedSeconds: 'trial_activation_modal_started_seconds',
  trialActivationModalDismissedSeconds: 'trial_activation_modal_dismissed_seconds',
  signupUserLoggedIn: 'signup_user_logged_in',
  signupProcessStarted: 'signup_process_started',
  signupProcessEmployeeSelected: 'signup_process_employee_selected',
  signupProcessOrgSelected: 'signup_process_org_selected',
  premiumActivationDismissed: 'premium_activation_dismissed',
  premiumActivationStarted: 'premium_activation_started',
  premiumTrialEndPlanSelected: 'premium_trial_end_plan_selected',
  premiumDiscoveryLinkClicked: 'premium_discovery_link_clicked',
  premiumTrialReactivatedFirst: 'premium_trial_reactivated_first',
  premiumTrialReactivatedCyclical: 'premium_trial_reactivated_cyclical',
  subscriptionCreditCardExpiresSoon: 'subscription_credit_card_expires_soon',
  subscriptionPaymentFailed: 'subscription_payment_failed',
  shiftBulkEditedEventsCount: 'shift_bulk_edited_events_count',
  shiftBulkEditedFieldsCount: 'shift_bulk_edited_fields_count',
  shiftTemplateUsed: 'shift_template_used',
  shiftTaskRowClickedByNonBusiness: 'shift_task_row_clicked_by_non_business',
  shiftTaskPageLedToPremiumPricing: 'shift_task_page_led_to_premium_pricing',
  emailCorrected: 'email_corrected',
  firstShiftCreated: 'first_shift_created',
  scheduleCreateUserSelected: 'schedule_create_user_selected',
  scheduleOptionsButtonClicked: 'schedule_options_button_clicked',
  trialExpiresIn4DaysLearnMore: 'trial_expires_in_4_days_learn_more',
  cancelSubscriptionAborted: 'cancel_subscription_aborted',
  cancelSubscriptionStarted: 'cancel_subscription_started',
  reportExported: 'report_exported',
  reportPrinted: 'report_printed',
  viewPlansClicked: 'view_plans_clicked',
  costsSaveInfoLearnMoreClicked: 'costs_save_info_learn_more_clicked',
  costsSaveInfoDismissed: 'costs_save_info_dismissed',
  horizontalMonthViewUsed: 'horizontal_month_view_used',
  messageEmployeeWorking: 'message_employee_working',
  metricsUserReordered: 'metrics_user_reordered',
};

export const ANALYTICS_BLACKLIST_DOMAINS = ['@gangverk.', '@getsling.', '@mailinator.'];

export const BY_LOCATION_SUFFIX = 'ByLocationId';

export const PUBLISH_SHIFT_WARNING_NOTIFY_EVERYONE = 'everyone';
export const PUBLISH_SHIFT_WARNING_NOTIFY_EMPLOYEE = 'employee';
export const PUBLISH_SHIFT_WARNING_NOTIFY_NOONE = 'noone';
export const PUBLISH_SHIFT_WARNING_NOTIFICATION_TYPES = [
  {
    value: PUBLISH_SHIFT_WARNING_NOTIFY_EVERYONE,
    label: 'Notify everyone',
  },
  {
    value: PUBLISH_SHIFT_WARNING_NOTIFY_EMPLOYEE,
    label: 'Notify employees with changes',
  },
  {
    value: PUBLISH_SHIFT_WARNING_NOTIFY_NOONE,
    label: 'Do not notify anyone',
  },
];
export const DEFAULT_COUNTRY_ENTRY = {
  label: 'United States +1',
  value: '+1',
  code: 'US',
};

export const DEFAULT_LABOR_DATA_KEYS = [
  'paidMinutes',
  'regularMinutes',
  'regularCost',
  'overtimeMinutes',
  'overtimeCost',
  'holidayRegularMinutes',
  'holidayRegularCost',
  'holidayOvertimeMinutes',
  'holidayOvertimeCost',
  'spreadOfHoursCost',
];

export const NO_GROUP_FILTER_OPTION_ID = 'noGroups';
export const NO_TAG_FILTER_OPTION_ID = 'noTags';
export const OTHER_DAY_PART_FILTER_OPTION_ID = 'otherDayPart';

export const CALENDAR_GROUP_CATEGORIES = {
  TAGS: 'tags',
  DAY_PARTS: 'dayParts',
};

export const DECIMAL_FORMAT_THOUSANDS_COMMA_DECIMAL_DOT = 'thousands_comma_decimal_dot';
export const DECIMAL_FORMAT_THOUSANDS_DOT_DECIMAL_COMMA = 'thousands_dot_decimal_comma';
export const PATTERN_THOUSANDS_COMMA = /^\d{1,}(,\d{3})*(\.\d*)?$/;
export const PATTERN_THOUSANDS_DOT = /^\d{1,}(\.\d{3})*(,\d*)?$/;

export const DAY_UNITS = 'DAYS';
export const DEFAULT_TASK_INSTANCES_FILTERS = {
  locationIds: [],
  positionIds: [],
  groupIds: [],
  userIds: [],
  statusIds: [],
  stateIds: [],
  eventIds: [],
};
export const TASK_INSTANCES_GROUP_BY_NONE = 'none';
export const TASK_INSTANCES_GROUP_BY_LOCATION = 'location';
export const TASK_INSTANCES_GROUP_BY_POSITION = 'position';
export const TASK_INSTANCES_GROUP_BY_STATUS = 'status';
export const DEFAULT_TASK_INSTANCES_GROUP_METHOD = TASK_INSTANCES_GROUP_BY_STATUS;
export const TASK_INSTANCES_SORT_BY_DATE = 'dtstart';
export const TASK_INSTANCES_SORT_BY_STATUS = 'status';
export const DEFAULT_TASK_INSTANCES_SORT_METHOD = TASK_INSTANCES_SORT_BY_DATE;
export const TASK_INSTANCE_UNASSIGNED_STATE = 'unassigned';
export const TASK_INSTANCE_AVAILABLE_STATE = 'available';
export const TASK_INSTANCE_ASSIGNED_STATE = 'assigned';
export const TASK_INSTANCE_PENDING_STATE = 'pending';
export const TASK_INSTANCE_COMPLETED_STATE = 'done';
export const TASK_INSTANCE_STATES = [
  { id: TASK_INSTANCE_COMPLETED_STATE, name: 'Completed' },
  { id: TASK_INSTANCE_PENDING_STATE, name: 'Not completed' },
];
export const TASK_INSTANCE_EVENT_TYPES = [
  { id: TASK_INSTANCE_ASSIGNED_STATE, name: 'Assigned' },
  { id: TASK_INSTANCE_AVAILABLE_STATE, name: 'Available' },
  { id: TASK_INSTANCE_UNASSIGNED_STATE, name: 'Unassigned' },
];
export const TASK_INSTANCES_STATUS_FILTER_NAME = 'statusIds';
export const TASK_INSTANCES_STATE_FILTER_NAME = 'stateIds';
export const TASK_INSTANCES_KNOWN_FILTERS = [
  'locationIds',
  'positionIds',
  'userIds',
  TASK_INSTANCES_STATUS_FILTER_NAME,
  TASK_INSTANCES_STATE_FILTER_NAME,
];
export const TASK_INSTANCES_KNOWN_FILTERS_TO_FILEDS_MAP = {
  locationIds: 'locationId',
  positionIds: 'positionId',
  userIds: 'assigneeId',
};
export const TASK_INSTANCE_PENDING_STATUS = 'pending';
export const TASK_INSTANCE_COMPLETED_STATUS = 'done';

export const USER_STATUSES = {
  VERIFIED: 'verified',
  UNVERIFIED: 'unverified',
  INVITED: 'invited',
  UNINVITED: 'uninvited',
  REQUESTED_INVITE: 'requested_invite',
  WRONG_EMAIL: 'wrong_email',
};

export const USER_BASE_WAGE_KEY = 'base';

export const PTO_FIXED_DATE_TYPE = 'FIXED';
export const PTO_HIRE_DATE_TYPE = 'HIRE';
export const PTO_RESET_DATE_OPTIONS = [
  { value: PTO_FIXED_DATE_TYPE, label: 'Common date' },
  { value: PTO_HIRE_DATE_TYPE, label: 'Hire date' },
];

export const PAYROLL_PERIOD_TYPES = {
  WEEKLY: 'Weekly',
  BI_WEEKLY: 'Bi-weekly',
  SEMI_MONTHLY: 'Semi-Monthly',
  MONTHLY: 'Monthly',
};

export const MINUTES_OPTION_VALUE = 'minutes';
export const HOURS_OPTION_VALUE = 'hours';
export const DURATION_UNIT_OPTIONS = [
  { value: MINUTES_OPTION_VALUE, label: 'Minutes' },
  { value: HOURS_OPTION_VALUE, label: 'Hours' },
];
export const DEFAULT_DURATION_UNIT = DURATION_UNIT_OPTIONS.find(
  (o) => o.value === MINUTES_OPTION_VALUE
);

export const SUBSCRIPTION_NAMES = {
  1: 'Premium',
  2: 'Business',
  3: 'Business',
};

export const MAIL_CHECK_CONFIG = {
  domains: [
    'gmail.com',
    'yahoo.com',
    'gangverk.is',
    'msn.com',
    'bellsouth.net',
    'telus.net',
    'comcast.net',
    'optusnet.com.au',
    'earthlink.net',
    'qq.com',
    'sky.com',
    'icloud.com',
    'mac.com',
    'sympatico.ca',
    'googlemail.com',
    'att.net',
    'xtra.co.nz',
    'web.de',
    'cox.net',
    'gmail.com',
    'ymail.com',
    'aim.com',
    'rogers.com',
    'verizon.net',
    'rocketmail.com',
    'google.com',
    'optonline.net',
    'sbcglobal.net',
    'aol.com',
    'me.com',
    'btinternet.com',
    'charter.net',
    'shaw.ca',
  ],
  secondLevelDomains: [
    'yahoo',
    'hotmail',
    'gmail',
    'mail',
    'live',
    'icloud',
    'outlook',
    'gangverk',
  ],
  topLevelDomains: [
    'com',
    'is',
    'com.au',
    'com.tw',
    'ca',
    'co.nz',
    'co.uk',
    'de',
    'fr',
    'it',
    'ru',
    'pl',
    'net',
    'org',
    'edu',
    'jp',
    'nl',
    'kr',
    'se',
    'eu',
    'ie',
    'co.il',
    'us',
    'at',
    'be',
    'dk',
    'hk',
    'es',
    'ch',
    'no',
    'cz',
    'in',
    'net',
    'net.au',
    'info',
    'biz',
    'mil',
    'co.jp',
    'sg',
    'hu',
    'uk',
  ],
};

export const UNAVAILABILITY_NO_REPEAT_VALUE = 0;
export const UNAVAILABILITY_INTERVALS = [
  { value: UNAVAILABILITY_NO_REPEAT_VALUE, label: 'Never' },
  { value: 1, label: 'Every week' },
  { value: 2, label: 'Every 2 weeks' },
  { value: 3, label: 'Every 3 weeks' },
  { value: 4, label: 'Every 4 weeks' },
];

export const RESTRICTION_TYPE = {
  NONE: 'NONE',
  PRIVILEGED_ONLY: 'PRIVILEGED_ONLY',
  SELECTED_ONLY: 'SELECTED_ONLY',
};

export const SHIFT_PENDING_ACCEPTANCE_STATUS = 'pending_acceptance';
export const SHIFT_ACCEPTED_STATUS = 'accepted';
export const SHIFT_REJECTED_STATUS = 'rejected';

export const MAX_CALENDAR_CONTRACTED_EVENTS = 3;
